<template>
  <div class="mb-12" :class="$vuetify.breakpoint.name === 'lg' ? 'pr-12 pl-8' : 'px-3'">
    <v-dialog v-model="dialog.delete" persistent max-width="400">
      <v-card class="pa-3">
        <v-card-title class="title">Peringatan !</v-card-title>
        <v-card-text>Apakah anda yakin ingin menghapus data ini ?</v-card-text>
        <v-card-actions class="pb-5">
          <v-spacer></v-spacer>
          <v-btn
            rounded
            small
            width="70"
            color="#FF618A"
            elevation="0"
            :disabled="process.form"
            :loading="process.form"
            class="white--text text-capitalize"
            @click="deletes">
            Yakin
          </v-btn>
          <v-btn
            rounded
            small
            width="70"
            elevation="0"
            class="text-capitalize"
            :disabled="process.form"
            @click="dialog.delete = false; type = ''">
            Tidak
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <v-dialog v-model="dialog.form" persistent max-width="400">
      <v-card class="pa-3">
        <div v-if="selectedPage === 'create' || selectedPage === 'update'">
          <div class="title text--secondary mb-5">
            {{ selectedPage === 'create' ? 'Tambah' : 'Ubah' }} Pengguna
          </div>
          <ValidationObserver ref="observer">
            <v-form>
              <!-- <ValidationProvider name="Username" rules="required" v-slot="{ errors }" v-if="selectedPage=== 'create'">
                <v-text-field
                  dense
                  outlined
                  label="Nama Pengguna"
                  color=" #fc2d63"
                  v-model="form.memberUsername"
                  :error-messages="errors"
                  require>
                </v-text-field>
              </ValidationProvider> -->
              <ValidationProvider name="Nama" rules="required" v-slot="{ errors }">
                <v-text-field
                  dense
                  outlined
                  label="Nama Lengkap"
                  color="#ff618a"
                  v-model="form.memberName"
                  :error-messages="errors"
                  require>
                </v-text-field>
              </ValidationProvider>
             
              <ValidationProvider name="Email" rules="required|email" v-slot="{ errors }"
                v-if="selectedPage === 'create'">
                <v-text-field
                  dense
                  outlined
                  color="#ff618a"
                  label="Email"
                  type="email"
                  v-model="form.memberEmail"
                  :error-messages="errors"
                  required>
                </v-text-field>
              </ValidationProvider>
              <ValidationProvider name="Telepon" rules="required|min:8|max:13" v-slot="{ errors }">
                <v-text-field
                  dense
                  outlined
                  label="Telepon"
                  color="#ff618a"
                  type="number"
                  v-model="form.memberPhoneNumber"
                  :error-messages="errors"
                  require>
                </v-text-field>
              </ValidationProvider>
               <p class="mb-1">
                Deskripsi (optional)
              </p>
              <quill-editor 
                ref="myTextEditor" 
                v-model="form.memberDesc" 
                :options="option">
              </quill-editor>
              <div class="mb-3">
                <p class="mt-5 mb-1">Gambar Profil (optional)</p>
                <form>
                  <v-card flat width="220" class="pa-0" style="background: transparent;">
                    <image-input v-model="avatar" type="uploadCover">
                      <div slot="activator">
                        <v-avatar tile size="100" height="100" class="grey lighten-3 cursor-pointer" v-ripple>
                           <v-icon v-if="!avatar && addImage === ''" color="grey darken-3" large>mdi-camera</v-icon>
                           <div class="px-5" v-if="addImage && avatar.url === undefined">
                            <v-progress-linear
                             color="#ff618a"
                              indeterminate
                              rounded
                              height="6"
                              class="mx-4 mt-4"
                              style="width: 80px;">
                            </v-progress-linear>
                            <p class="mt-2 mx-4 mb-0" style="font-size: 9px;">
                              Mengupload Gambar . . .
                            </p>
                          </div>
                          <img v-if="avatar && !addImage" :src="form.memberImage" :alt="form.memberImage" />
                        </v-avatar>
                      </div>
                    </image-input>
                  </v-card>
                </form>
              </div>
              <div>
                <v-alert type="error" text dense prominent v-show="response !== ''">{{ response }}</v-alert>
              </div>
              <v-card-actions class="mt-5">
                <v-spacer></v-spacer>
                <v-btn
                  small
                  rounded
                  width="100"
                  color="#ff618a"
                  elevation="0"
                  :disabled="process.form"
                  :loading="process.form"
                  @click="save"
                  class="white--text text-capitalize">
                  Simpan
                </v-btn>
                <v-btn
                  rounded
                  small
                  width="100"
                  elevation="0"
                  class="text-capitalize"
                  :disabled="process.form"
                  @click="reset(undefined, 'mobile'); selectedPage = 'create'; $refs.observer.reset()">
                  Batal
                </v-btn>
              </v-card-actions>
            </v-form>
          </ValidationObserver>
        </div>

        <div v-if="selectedPage === 'detail'">
          <div class="text-center">
            <v-avatar
              width="100" 
              height="100">
              <v-img 
                width="100" 
                height="100"
                :src="member.userUrlImg"
                class="mx-auto br-20 cursor-pointer">
              </v-img>
            </v-avatar>
          </div>
          <div class="mt-10">
            <v-list-item-title
              class="body-2 grey--text text--darken-2">
              <p class="caption grey--text text-lighten-4 mb-1">
                Nama Lengkap
              </p>
               {{member.userFullname}}
            </v-list-item-title>
           
            <v-list-item-title  
              class="body-2 grey--text text--darken-2 mt-2">
              <p class="caption grey--text text-lighten-4 mb-1">
               Telepon
              </p>
              {{ member.userPhoneNumber !== '' ? member.userPhoneNumber : 'xxxx-xxxx-xxxx' }}
            </v-list-item-title>

             <v-list-item-title
              class="body-2 grey--text text--darken-2 mt-2">
              <p class="caption grey--text text-lighten-4 mb-1">
               Email
              </p>
              {{member.userEmail}}
            </v-list-item-title>

            <p class="caption grey--text text-lighten-4 mb-1 mt-3">
              Deskripsi
            </p>
            <p class="body-2 grey--text text--darken-2"
            v-html="member.userDesc !== '' ? member.userDesc : '-'">
            </p>
          </div>
          <v-card-actions class="pb-5">
            <v-spacer></v-spacer>
            <v-btn
              rounded
              small
              width="100"
              elevation="0"
              class="text-capitalize"
              @click="reset(undefined, 'mobile'); selectedPage = 'detail'">
              Tutup
            </v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog 
      v-model="dialog.pic" 
      persistent
      width="650">
      <v-card class="pa-5">
        <v-img
          width="100%" 
          :src="member.userUrlImg"
          playsinline 
          controls>
        </v-img>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            small
            rounded
            width="100"
            elevation="0"
            class="text-capitalize mt-5 mb-0"
            @click="dialog.pic = false;">
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col cols="12" :sm="showPage === false ? '12' : '8'">
        <div :class="$vuetify.breakpoint.name !== 'xs' ? 'd-flex' : ''">
          <v-text-field
            filled
            rounded
            dense
            :hide-details="true"
            placeholder="Cari pengguna . . ."
            v-model="filter.username"
            clearable
            color="#ff618a"
            @click:clear="filter.username = ''; fetch();showPage = false;"
            v-on:keyup.enter="fetch();showPage = false"
            prepend-inner-icon="mdi-magnify">
          </v-text-field>
          <v-btn
            :color="!showPage ? '#FF618A' : '#F5F5F5'"
            :width="$vuetify.breakpoint.name === 'xs' ? '100%' : '200'"
            class="text-capitalize"
            :class="$vuetify.breakpoint.name === 'xs' ? 'mt-3' : 'mx-3'"
            :dark="!showPage"
            elevation="0"
            rounded
            :light="showPage"
            :disabled="process.form"
            v-on:click="$vuetify.breakpoint.name === 'xs' ? reset(undefined, 'mobile') : $vuetify.breakpoint.name === 'sm' ? reset(undefined, 'mobile') : reset()"
            @click="selectedPage = 'create';">
            <span v-if="!showPage">Tambah Pengguna</span>
            <span v-if="showPage">Kembali</span>
          </v-btn>
        </div>

        <div class="my-5">
          <div class="title text--secondary">Data Pengguna</div>
          <div class="caption text--secondary">{{pagination.totalData}} Pengguna Ditemukan</div>
          <v-skeleton-loader
             class="ma-auto"
            :loading="process.run"
            transition="scale-transition"
            :tile="false"
            type="list-item-avatar-two-line"
            v-for="(l, index) in process.run ? 10:list"
            :key="index">
            <v-list dense class="line my-3 mr-5">
              <v-list-item>
                 <v-list-item-avatar @click="$vuetify.breakpoint.name === 'xs' ? toDetail(l, 'mobile') : $vuetify.breakpoint.name === 'sm' ? toDetail(l, 'mobile') : toDetail(l)" class="cursor-pointer mr-3">
                  <v-img :src="l.userUrlImg"></v-img>
                </v-list-item-avatar>

                <v-list-item-content @click="$vuetify.breakpoint.name === 'xs' ? toDetail(l, 'mobile') : $vuetify.breakpoint.name === 'sm' ? toDetail(l, 'mobile') : toDetail(l)" class="cursor-pointer">
                  <v-list-item-title
                    class="body-2 font-weight-bold grey--text text--darken-2">
                  {{l.userFullname}}
                  </v-list-item-title>
                  <v-list-item-subtitle
                    v-if="$vuetify.breakpoint.name !== 'xs'"
                    class="caption mt-1 grey--text text--darken-2 text-capitalize font-weight-thin">
                    Nama Lengkap
                  </v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-content @click="$vuetify.breakpoint.name === 'xs' ? toDetail(l, 'mobile') : $vuetify.breakpoint.name === 'sm' ? toDetail(l, 'mobile') : toDetail(l)" class="cursor-pointer">
                  <v-list-item-title
                    class="body-2 font-weight-bold grey--text text--darken-2">
                  {{l.userName}}
                  </v-list-item-title>
                </v-list-item-content>

                <v-list-item-content @click="$vuetify.breakpoint.name === 'xs' ? toDetail(l, 'mobile') : $vuetify.breakpoint.name === 'sm' ? toDetail(l, 'mobile') : toDetail(l)" class="cursor-pointer" v-if="$vuetify.breakpoint.name !== 'xs'">
                  <v-list-item-title class="body-2 grey--text text--darken-2 d-flex">
                    <div>
                      <v-icon class="mr-2">mdi-email</v-icon>
                      {{l.userEmail}}
                    </div>
                  </v-list-item-title>
                  <v-list-item-subtitle
                    class="caption mt-1 grey--text text--darken-2 text-capitalize font-weight-thin">
                    Email
                  </v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-content @click="$vuetify.breakpoint.name === 'xs' ? toDetail(l, 'mobile') : $vuetify.breakpoint.name === 'sm' ? toDetail(l, 'mobile') : toDetail(l)" class="cursor-pointer" v-if="$vuetify.breakpoint.name !== 'xs'">
                  <v-list-item-title class="body-2 grey--text text--darken-2 d-flex">
                    <div>
                      <v-icon class="mr-2">mdi-phone</v-icon>
                      {{ l.userPhoneNumber !== '' ? l.userPhoneNumber : 'xxxx-xxxx-xxxx' }}
                    </div>
                  </v-list-item-title>
                  	 <v-list-item-subtitle
                    class="caption mt-1 grey--text text--darken-2 text-capitalize font-weight-thin">
                   Telepon
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-content class="text-right">
                  <div>
                    <v-btn
                      fab
                      x-small
                      :disabled="process.form"
                      color="#269B91"
                      elevation="0"
                      class="text-capitalize white--text ma-1"
                       v-on:click="$vuetify.breakpoint.name === 'xs' ? reset(l, 'mobile') : $vuetify.breakpoint.name === 'sm' ? reset(l, 'mobile') : reset(l)"
                      @click="selectedPage = 'update'">
                      <v-icon small>mdi-square-edit-outline</v-icon>
                    </v-btn>
                    <v-btn 
                      fab
                      x-small
                      :disabled="process.form"
                      color="red"
                      elevation="0"
                      class="text-capitalize white--text ma-1"
                      @click="form.memberId=l.id; dialog.delete=true">
                      <v-icon small>mdi-trash-can-outline</v-icon>
                    </v-btn>
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-skeleton-loader>
          <Empty v-show="!process.run && list.length < 1" content="Data Pengguna"/>
          <div v-if="pagination.totalPage > 1">
            <v-row>
              <v-col cols="5">
                <div class="body-2 font-weight-bold mt-4">Total {{ pagination.totalData }} data</div>
              </v-col>
              <v-col cols="7">
                <div class="float-right">
                  <v-pagination
                    v-model="page"
                    :length="pagination.totalPage"
                    :total-visible="5"
                    color="#ff618a"
                    @input="fetch(page);showPage = false"
                    circle>
                  </v-pagination>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-col>

      <v-col cols="12" sm="4" class="mt-3 background-default pa-7" v-if="showPage">
        <div v-if="selectedPage === 'create' || selectedPage === 'update'">
          <div class="title text--secondary mb-5">
            {{ selectedPage === 'create' ? 'Tambah' : 'Ubah' }} member
          </div>
          <ValidationObserver ref="observer">
            <v-form>
              <!-- <ValidationProvider name="Username" rules="required" v-slot="{ errors }"  v-if="selectedPage=== 'create'">
                <v-text-field
                  dense
                  outlined
                  label="Nama Pengguna"
                  color=" #fc2d63"
                  v-model="form.memberUsername"
                  :error-messages="errors"
                  require>
                </v-text-field>
              </ValidationProvider> -->
              <ValidationProvider name="Nama" rules="required" v-slot="{ errors }">
                <v-text-field
                  dense
                  outlined
                  label="Nama Lengkap"
                  color="#ff618a"
                  v-model="form.memberName"
                  :error-messages="errors"
                  require>
                </v-text-field>
              </ValidationProvider>
               <ValidationProvider name="Email" rules="required|email" v-slot="{ errors }"
                v-if="selectedPage === 'create'">
                <v-text-field
                  dense
                  outlined
                  color="#ff618a"
                  label="Email"
                  type="email"
                  v-model="form.memberEmail"
                  :error-messages="errors"
                  required>
                </v-text-field>
              </ValidationProvider>
              <ValidationProvider name="Telepon" rules="required|min:8|max:13" v-slot="{ errors }">
                <v-text-field
                  dense
                  outlined
                  label="Telepon"
                  color="#ff618a"
                  type="number"
                  v-model="form.memberPhoneNumber"
                  :error-messages="errors"
                  require>
                </v-text-field>
              </ValidationProvider>
               <p class="mb-1">
                Deskripsi (optional)
              </p>
              <quill-editor 
                ref="myTextEditor" 
                v-model="form.memberDesc" 
                :options="option">
              </quill-editor>
              <div class="mb-3">
                <p class="mt-5 mb-1">Gambar Profil (optional)</p>
                <form>
                 <v-card flat width="220" class="pa-0" style="background: transparent;">
                    <image-input v-model="avatar" type="uploadCover">
                      <div slot="activator">
                        <v-avatar tile size="100" height="100" class="grey lighten-3 cursor-pointer" v-ripple>
                           <v-icon v-if="!avatar && addImage === ''" color="grey darken-3" large>mdi-camera</v-icon>
                           <div class="px-5" v-if="addImage && avatar.url === undefined">
                            <v-progress-linear
                             color="#ff618a"
                              indeterminate
                              rounded
                              height="6"
                              class="mx-4 mt-4"
                              style="width: 80px;">
                            </v-progress-linear>
                            <p class="mt-2 mx-4 mb-0" style="font-size: 9px;">
                              Mengupload Gambar . . .
                            </p>
                          </div>
                          <img v-if="avatar && !addImage" :src="form.memberImage" :alt="form.memberImage" />
                        </v-avatar>
                      </div>
                    </image-input>
                  </v-card>
                </form>
              </div>
              <div>
                <v-alert type="error" text dense prominent v-show="response !== ''">{{ response }}</v-alert>
              </div>
              <v-card-actions class="mt-5">
                <v-spacer></v-spacer>
                <v-btn
                  rounded
                  width="200"
                  color="#ff618a"
                  elevation="0"
                  :disabled="process.form"
                  :loading="process.form"
                  @click="save"
                  class="white--text text-capitalize">
                  Simpan
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-form>
          </ValidationObserver>
        </div>

        <div v-if="selectedPage === 'detail'">
          <div class="text-center">
            <v-avatar
              width="100" 
              height="100">
              <v-img 
                width="100" 
                height="100"
                :src="member.userUrlImg"
                @click="dialog.pic = true"
                class="mx-auto br-20 cursor-pointer">
              </v-img>
            </v-avatar>
          </div>
          <div class="mt-10">
            <v-list-item-title
              class="body-2 grey--text text--darken-2">
              <p class="caption grey--text text-lighten-4 mb-1">
                Nama Lengkap
              </p>
               {{member.userFullname}}
            </v-list-item-title>
           
            <v-list-item-title  
              class="body-2 grey--text text--darken-2 mt-2">
              <p class="caption grey--text text-lighten-4 mb-1">
               Telepon
              </p>
              {{ member.userPhoneNumber !== '' ? member.userPhoneNumber : 'xxxx-xxxx-xxxx' }}
            </v-list-item-title>

            <v-list-item-title
              class="body-2 grey--text text--darken-2 mt-2">
              <p class="caption grey--text text-lighten-4 mb-1">
               Email
              </p>
              {{member.userEmail}}
            </v-list-item-title>

            <p class="caption grey--text text-lighten-4 mb-1 mt-3">
              Deskripsi
            </p>
            <p class="body-2 grey--text text--darken-2"
            v-html="member.userDesc !== '' ? member.userDesc : '-'">
            </p>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../../../service/Axios";
  import ImageInput from "../../../components/ImageInput.vue";
  import Empty from "../../../components/DataEmpty";
  export default {
    data() {
      return {
        option: {
          modules: {
            toolbar: [
              ["bold", "italic", "underline"],
              [{ list: "ordered" }, { list: "bullet" }],
              [{ size: ["small", false, "large", "huge"] }],
              [{ color: [] }, { background: [] }],
              [{ align: [] }]
            ]
          },
          placeholder: 'Deskripsi . . .'
        },
        dialog: {
          delete: false,
          form: false,
          pic:false
        },
        showPage: false,
        selectedPage: "",
        filter: {
          username: ""
        },
        addImage:'',
        member: {},
        list: [],
        pagination: {},
        page: 1,
        avatar: null,
        form: {
          memberId:"",
          memberEmail: "",
          memberPhoneNumber: "",
          memberName: "",
          memberDesc: "",
          memberImage:""
        },
        process: {
          form: false,
          run: false
        },
        response: ""
      };
    },
    watch: {
      avatar: {
        handler: function () {
          this.form.memberImage = this.avatar ? this.avatar.url : ""
          this.addImage = this.avatar.add
          // this.error.memberImage = ''
        },
        deep: true
      }
    },
    components: {
      ImageInput,
      Empty
    },
    computed: {},
    mounted() {
      window.scrollTo(0, 0);
      this.fetch();
    },
    methods: {
      async fetch(p) {
        this.process.run = true;
        await get(`api/internal/users/list`, {
          params: {
            pagenum: p,
            limit: 10,
            search:this.filter.username ? 'user_name:'+this.filter.username+',user_phone_number:'+this.filter.username+',user_email:'+this.filter.username : '',
            type: 'user'
          }
        }).then(response => {
          let res = response.data
          if (res.code === 200) {
            this.process.run = false
            this.list = res.data
            this.pagination = res.pagination
          }
        })
      },
      toDetail(item, status) {
        this.member = item
        this.selectedPage = "detail"
        this.member.userDesc = this.member.userDesc.replace(/&lt;/g, "<");
        this.showPage = status !== undefined ? false : true
        this.dialog.form = status !== undefined ? true : false
      },
      reset(item, status) {
        this.showPage = status !== undefined ? false : !this.showPage ? true : false

        this.avatar = item !== undefined ? {
          url: item.userUrlImg
        } : null
        this.addImage = item !== undefined ? false : ""
        this.form = {
          memberId: item !== undefined ? item.id : "",
          memberEmail : item !== undefined ? item.userEmail : "",
          memberPhoneNumber: item !== undefined ? item.userPhoneNumber : "",
          memberName: item !== undefined ? item.userFullname : "",
          memberDesc: item !== undefined ? item.userDesc.replace(/&lt;/g, "<") : "",
          memberImage: item !== undefined ? item.userUrlImg : ""
        }
        this.dialog.form = status !== undefined ? !this.dialog.form ? true : false : false

        this.selectedPage = ''
        this.process.form = false

        this.response = ''
      },
       async save() {
        this.response = "";
        const isValid = await this.$refs.observer.validate();
        if (isValid) {
          if (this.form.memberId === "") {
            this.creates();
          } else {
            this.updates();
          }
        }
      },
      async creates() {
        this.process.form = true;
        await post(`api/internal/users/create`, {
          data: {
            email: this.form.memberEmail,
            password: '12345678',
            passwordConfirm: '12345678',
            phoneNumber: this.form.memberPhoneNumber,
            fullName: this.form.memberName,
            // username: this.form.memberUsername,
            desc: this.form.memberDesc,
            urlImg: this.form.memberImage,
            role:'user',
            privilege: []
          }
        }).then(response => {
          let res = response.data;
          if (res.code == 201) {
            this.fetch();
            if (this.dialog.form === true) {
              this.reset(undefined, 'mobile')
            } else {
              this.reset();
            }
          } else {
            this.process.form = false;
            this.response = res.msg;
          }
        });
      },
      async updates() {
        this.process.form = true;
        await put(`api/internal/users/update/${this.form.memberId}`, {
          data: {
            fullName: this.form.memberName,
            // username: this.form.memberUsername,
            desc: this.form.memberDesc,
            phoneNumber: this.form.memberPhoneNumber,
            urlImg: this.form.memberImage,
            role:'user',
            privilege: []
          }
        }).then(response => {
          let res = response.data;
          if (res.code === 201) {
            this.fetch();
            if (this.dialog.form === true) {
              this.reset(undefined, 'mobile')
            } else {
              this.reset();
            }
          } else {
            this.process.form = false;
            this.response = res.msg;
          }
        });
      },
      async deletes(){
         this.process.form = true;
         await destroy(`api/internal/users/delete/${this.form.memberId}`).then((response) => {
           let res = response.data
           if(res.code == 201){
            this.process.form = false
            this.dialog.delete = false
            this.showPage = false
            this.fetch()
           }else{
            this.process.form = false
            this.response = res.msg
           }
         })
      }
    }
  }
</script>

<style scoped>
.br-20 {
  border-radius: 20px;
}
</style>

